export const DEFAULT_WEBSITE_DOMAIN = "www.casinob8.com";
